import { render, staticRenderFns } from "./InformationSummaries.vue?vue&type=template&id=7e4e4ff8&lang=pug&"
import script from "./InformationSummaries.vue?vue&type=script&lang=js&"
export * from "./InformationSummaries.vue?vue&type=script&lang=js&"
import style0 from "./InformationSummaries.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "InformationSummaries.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {
  VFlex,
  VIcon,
  VLayout,
})
